module.exports = __webpack_public_path__ + "static/media/play.415b5290.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.svg
// module id = 508
// module chunks = 0